"use client";
// Imports
import { useState } from "react";
import { Icon, Img } from "@/components";
import { formatEventTimeLabel } from "@/lib/showDates";
import { Minus, Plus } from "lucide-react";

export function SubEventsList({ events }) {
  const [selectedEvent, setSelectedEvent] = useState(null);

  return (
    <div className="pt-2 space-y-4 lg:pt-4">
      {events?.length > 0 &&
        events.map((event, index) => {
          const isOpen = selectedEvent === event?.id;
          if (!event?.override_display_data) return null;
          const startLabel = formatEventTimeLabel(event?.start_time, {
            empty: "",
          });

          return (
            <div
              key={index}
              className="overflow-hidden bg-white border-2 shadow-lg border-foreground/10 rounded-card-radius"
            >
              <button
                type="button"
                onClick={() =>
                  setSelectedEvent(isOpen ? null : event?.id)
                }
                className="flex items-center justify-between w-full gap-4 px-4 py-3 text-left transition-colors cursor-pointer lg:hover:bg-brand-wool/40"
              >
                <h3 className="level-4">{event?.override_title}</h3>
                <div className="flex items-center shrink-0 gap-3">
                  {startLabel ? (
                    <div className="flex items-center gap-2">
                      <Icon icon="clock" size={20} />
                      <p>{startLabel}</p>
                    </div>
                  ) : null}
                  {isOpen ? (
                    <Minus className="w-5 h-5 shrink-0" aria-hidden />
                  ) : (
                    <Plus className="w-5 h-5 shrink-0" aria-hidden />
                  )}
                </div>
              </button>
              {isOpen && <SubEventDetails event={event} />}
            </div>
          );
        })}
    </div>
  );
}

function SubEventDetails({ event }) {
  return (
    <div className="flex items-start justify-start gap-6 px-4 py-4 bg-white border-t-2 border-foreground/10">
      {event?.override_grid?.permalink && (
        <div className="relative size-[100px] shrink-0 overflow-hidden rounded-card-radius">
          <Img
            className="object-cover"
            data={event?.override_grid}
            fill
            sizes="100px"
          />
        </div>
      )}
      <div className="flex flex-col min-w-0">
        <p>{event?.override_short}</p>
      </div>
    </div>
  );
}
